import { create } from "zustand";
import { api } from "../lib/api";

type Pending = {
  id: string;
  url: string;
  method: "POST" | "PATCH";
  body: unknown;
  attempts: number;
};

type State = {
  pending: Pending[];
  enqueue: (p: Omit<Pending, "id" | "attempts">) => void;
  flush: () => Promise<void>;
};

const DB_KEY = "tcg-inv-hub-queue";

function load(): Pending[] {
  try {
    return JSON.parse(localStorage.getItem(DB_KEY) || "[]");
  } catch {
    return [];
  }
}
function save(items: Pending[]) {
  localStorage.setItem(DB_KEY, JSON.stringify(items));
}

export const useQueue = create<State>((set, get) => ({
  pending: load(),
  enqueue: (p) => {
    const item = { ...p, id: crypto.randomUUID(), attempts: 0 };
    const items = [...get().pending, item];
    save(items);
    set({ pending: items });
  },
  flush: async () => {
    const items = [...get().pending];
    const remaining: Pending[] = [];
    for (const it of items) {
      try {
        await api.request({ url: it.url, method: it.method, data: it.body, headers: { "X-Idempotency-Key": it.id } });
      } catch {
        remaining.push({ ...it, attempts: it.attempts + 1 });
      }
    }
    save(remaining);
    set({ pending: remaining });
  },
}));

if (typeof window !== "undefined") {
  window.addEventListener("online", () => useQueue.getState().flush());
}
